webpackJsonp([99110987824835],{

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var data = __webpack_require__(153);
	
	if (({"NODE_ENV":"production","PUBLIC_DIR":"/codebuild/output/src044587584/src/public"}).gatsby_executing_command === 'develop') {
	  // Add some items with testing values
	  data.push();
	}
	
	module.exports = data;

/***/ }),

/***/ 153:
/***/ (function(module, exports) {

	module.exports = [{"name":"Brian Slingsby","personType":"STAFF","memoryDate":"1980","submissionDate":1474885780685,"text":"It was a terrible thing. Because nobody expected it. Nobody outside the directors knew it was going to happen. I mean – I charged - filled up every pot on the Friday night. Just came round - “We're closing!”\nLeaving that aside. That was the thing to do. Because we had all that batch mix ready for the weekend. What are you going to do with it? You don't want it left there if you are going to close. You want it melted down into something which is innocuous. But I mean it was such a shock – such a shock - it devastated people. Lots of people who had worked at the place for ages, and their families had worked at the place for ages. It was all very sad as well. I won't say you can blame anything it was just how things had gone.\nBecause within another ten years all the other major factories had closed as well. It was the ingress of technology you know. Technology creeps in at the bottom end and takes all your bread and butter stuff away. And then you are only left with the stuff after that. You see melting from a tank furnace is totally different from melting from a pot furnace. Its a different world - but it was a very sad time.","relatedItems":[]},{"name":"Brian Slingsby","personType":"STAFF","memoryDate":"1980","submissionDate":1474885780684,"text":"The phone went and it was Roy Raiken's wife. She said “He's away. I've had the police on. There's propane escaping.” I thought 'Oh my God'. Because the electric railway line - your main Euston line - was just across the road from it. So I got in the car and sped off down there. First of all they would not let me in. There was everybody in the land there – police, ambulance, water, fire brigade. As soon as I walked through the arch I thought 'My time is up.' Because there was propane vapour about that deep completely covering the car park. I thought 'One spark here and we are all goners.'","relatedItems":[]}]

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(12);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _stylesModule = __webpack_require__(135);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _SelectArrows = __webpack_require__(85);
	
	var _SelectArrows2 = _interopRequireDefault(_SelectArrows);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _classnames;
	
	  var id = _ref.id,
	      label = _ref.label,
	      options = _ref.options,
	      selectedValue = _ref.selectedValue,
	      value = _ref.value,
	      onChange = _ref.onChange,
	      required = _ref.required;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames3.default)(_stylesModule2.default.container, (_classnames = {}, _classnames[_stylesModule2.default.blankValue] = !(value || selectedValue), _classnames))
	    },
	    _react2.default.createElement(
	      'label',
	      { htmlFor: id },
	      label,
	      required && _react2.default.createElement(
	        'span',
	        { className: _stylesModule2.default.required },
	        '(required)'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'select',
	        {
	          id: id,
	          name: id,
	          value: value || selectedValue,
	          onChange: onChange
	        },
	        options.map(function (_ref2, index) {
	          var text = _ref2.text,
	              optionValue = _ref2.value;
	          return _react2.default.createElement(
	            'option',
	            { key: index, value: optionValue },
	            text
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.arrowContainer },
	        _react2.default.createElement(_SelectArrows2.default, { size: 16 })
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-drop-down----styles-module---container---yOxcw","blankValue":"src-components-contribution-form-form-components-drop-down----styles-module---blankValue---1c04v","arrowContainer":"src-components-contribution-form-form-components-drop-down----styles-module---arrowContainer---27oz_","required":"src-components-contribution-form-form-components-drop-down----styles-module---required---2xSA-"};

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(136);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	var _emailNotice = __webpack_require__(160);
	
	var _emailNotice2 = _interopRequireDefault(_emailNotice);
	
	var _Checkbox = __webpack_require__(159);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailInput = function (_Component) {
	  _inherits(EmailInput, _Component);
	
	  function EmailInput() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EmailInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      emailSaved: false
	    }, _this.setEmailValue = function (event) {
	      _this.props.setEmailValue(event);
	      if (_this.state.emailSaved) {
	        window.localStorage.setItem('saved-email', _this.props.emailValue);
	      }
	    }, _this.toggleSaveChoice = function (event) {
	      if (_this.state.emailSaved) {
	        // Disabling so clear stored value
	        console.log('clearing');
	        window.localStorage.setItem('saved-email', '');
	      } else {
	        console.log('saving', _this.props.emailValue);
	        window.localStorage.setItem('saved-email', _this.props.emailValue);
	      }
	
	      _this.setState(function (state) {
	        return { emailSaved: !state.emailSaved };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  EmailInput.prototype.componentDidMount = function componentDidMount() {
	    var foundEmail = window.localStorage.getItem('saved-email');
	
	    if (foundEmail) {
	      this.setState({ emailSaved: true });
	      this.props.setEmailValue({ target: { value: foundEmail } });
	    }
	  };
	
	  EmailInput.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_textBox2.default, {
	        required: true,
	        type: 'email',
	        id: _text2.default.FORMS.emailId,
	        label: _text2.default.FORMS.emailLabel,
	        placeholder: _text2.default.FORMS.emailPlaceholder,
	        value: this.props.emailValue,
	        onChange: this.setEmailValue
	      }),
	      _react2.default.createElement(
	        'label',
	        {
	          className: _stylesModule2.default.checkboxLabel,
	          htmlFor: 'save-email',
	          onClick: function onClick(event) {
	            event.preventDefault();
	            _this2.toggleSaveChoice(event);
	          }
	        },
	        _react2.default.createElement(_Checkbox2.default, {
	          borderStyle: true,
	          color: '#fff',
	          type: 'checkbox',
	          id: 'save-email',
	          value: this.state.emailSaved,
	          onChange: this.toggleSaveChoice
	        }),
	        _react2.default.createElement(
	          'span',
	          null,
	          'Remember email address'
	        )
	      ),
	      _react2.default.createElement(_emailNotice2.default, null)
	    );
	  };
	
	  return EmailInput;
	}(_react.Component);
	
	exports.default = EmailInput;
	module.exports = exports['default'];

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"checkboxLabel":"src-components-contribution-form-form-components-email-input----styles-module---checkboxLabel---2W0Zo"};

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(137);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _Warning = __webpack_require__(128);
	
	var _Warning2 = _interopRequireDefault(_Warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var title = _ref.title,
	      message = _ref.message;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(_Warning2.default, { color: '#AD343E', size: null }),
	    _react2.default.createElement(
	      'div',
	      null,
	      title && _react2.default.createElement(
	        'h3',
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        message
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-error-message----styles-module---container---3FWZ3"};

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(138);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _Tooltip = __webpack_require__(60);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var submitText = _ref.submitText,
	      submitOnClick = _ref.submitOnClick,
	      submitDisabled = _ref.submitDisabled,
	      submitDisabledMessage = _ref.submitDisabledMessage,
	      cancelText = _ref.cancelText,
	      cancelOnClick = _ref.cancelOnClick;
	
	  var submitButton = _react2.default.createElement(_pillButton2.default, {
	    id: 'submit-form',
	    type: 'submit',
	    preventDefault: true,
	    text: submitText,
	    onClick: submitOnClick,
	    disabled: submitDisabled
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    submitDisabled ? _react2.default.createElement(
	      _Tooltip2.default,
	      { above: true, error: true, text: submitDisabledMessage },
	      submitButton
	    ) : submitButton,
	    _react2.default.createElement(_pillButton2.default, {
	      preventDefault: true,
	      theme: 'grey-ghost',
	      text: cancelText,
	      onClick: cancelOnClick
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-form-buttons----styles-module---container---1atrA"};

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _formValidator = __webpack_require__(47);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function capsFirst(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	var arrayFields = ['images', 'relatedItems'];
	
	var FormController = function (_Component) {
	  _inherits(FormController, _Component);
	
	  function FormController(props, fieldNames, requiredFields, pages) {
	    _classCallCheck(this, FormController);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.updateValue = function (property, value) {
	      _this.setState(function (state) {
	        var _ref;
	
	        return _ref = {}, _ref[property] = value, _ref;
	      });
	      _this.setState(function (state) {
	        return { formValid: _this.validate(state) };
	      });
	    };
	
	    _this.validate = function (state) {
	      return (0, _formValidator.validateFields)(_this.requiredFields, state);
	    };
	
	    _this.validationMessage = function () {
	      return (0, _formValidator.getValidationMessage)(_this.requiredFields, _this.state);
	    };
	
	    _this.extractFields = function () {
	      // Fields are all text inputs indicated by ending in the word "Value"
	      var fields = Object.keys(_this.state).filter(function (key) {
	        return key.endsWith('Value');
	      }).reduce(function (result, key) {
	        var _extends2;
	
	        return _extends(result, (_extends2 = {}, _extends2[key.replace('Value', '')] = _this.state[key], _extends2));
	      }, {});
	
	      if (_this.fieldNames.includes('relatedItems')) {
	        fields.relatedItems = _this.state.relatedItems.join(',');
	      }
	
	      return fields;
	    };
	
	    _this.submit = function () {
	      _this.props.submitForm({ fields: _this.extractFields(), images: _this.state.images }, _this.state);
	    };
	
	    _this.getFooterProps = function (submitOverride, submitDisabled, submitDisabledMessage) {
	      var firstPage = _this.state.stage === 1;
	      var lastPage = _this.state.stage === _this.pages;
	
	      return {
	        submitText: lastPage ? _text2.default.COMMON_LABELS.submitText : _text2.default.COMMON_LABELS.nextText,
	        submitOnClick: lastPage ? submitOverride || _this.submit : _this.nextPage,
	        submitDisabled: lastPage && (submitDisabled !== undefined ? submitDisabled : !_this.state.formValid),
	        submitDisabledMessage: lastPage && (submitDisabledMessage !== undefined ? submitDisabledMessage : _this.validationMessage(_this.state)),
	        cancelText: firstPage ? _text2.default.COMMON_LABELS.cancelText : _text2.default.COMMON_LABELS.backText,
	        cancelOnClick: firstPage ? _this.props.closeForm : _this.backPage
	      };
	    };
	
	    _this.nextPage = function () {
	      return _this.setState(function (state) {
	        return { stage: state.stage + 1 };
	      });
	    };
	
	    _this.backPage = function () {
	      return _this.setState(function (state) {
	        return { stage: state.stage - 1 };
	      });
	    };
	
	    _this.pages = pages;
	    // Store field name config
	    _this.fieldNames = fieldNames;
	
	    if (!requiredFields) {
	      _this.requiredFields = fieldNames;
	    } else {
	      _this.requiredFields = requiredFields;
	    }
	
	    // Set state
	    if (props.recoveryState) {
	      _this.state = props.recoveryState;
	    } else {
	      _this.state = _extends({
	        // Form defaults to invalid
	        formValid: false,
	
	        stage: 1
	
	      }, fieldNames.reduce(function (result, fieldName) {
	        var _extends3, _extends4;
	
	        return (
	          // The images field is an array not a string
	          arrayFields.includes(fieldName) ? _extends(result, (_extends3 = {}, _extends3[fieldName] = [], _extends3)) : _extends(result, (_extends4 = {}, _extends4[fieldName] = '', _extends4))
	        );
	      }, {}));
	    }
	
	    // Create field update listeners
	    fieldNames.forEach(function (fieldName) {
	      _this['set' + capsFirst(fieldName)] = arrayFields.includes(fieldName) ? function (images) {
	        return _this.updateValue(fieldName, images);
	      } : function (event) {
	        return _this.updateValue(fieldName, event.target.value);
	      };
	    });
	    return _this;
	  }
	
	  return FormController;
	}(_react.Component);
	
	exports.default = FormController;
	module.exports = exports['default'];

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stylesModule = __webpack_require__(139);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      nested = _ref.nested;
	  return _react2.default.createElement(
	    'form',
	    { className: (0, _classnames2.default)(_stylesModule2.default.container, nested && _stylesModule2.default.nested) },
	    children
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-form-wrapper----styles-module---container---2aOqt","nested":"src-components-contribution-form-form-components-form-wrapper----styles-module---nested---2Ivgv"};

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(140);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _Tooltip = __webpack_require__(60);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _square = __webpack_require__(56);
	
	var _square2 = _interopRequireDefault(_square);
	
	var _Cross = __webpack_require__(28);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	var _TickOutline = __webpack_require__(163);
	
	var _TickOutline2 = _interopRequireDefault(_TickOutline);
	
	var _Tick = __webpack_require__(62);
	
	var _Tick2 = _interopRequireDefault(_Tick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageTile = function ImageTile(_ref) {
	  var image = _ref.image,
	      isMain = _ref.isMain,
	      mainDisabled = _ref.mainDisabled,
	      setMainClick = _ref.setMainClick,
	      removeClick = _ref.removeClick;
	
	  var mainButton = _react2.default.createElement(
	    'button',
	    {
	      type: 'button',
	      disabled: mainDisabled,
	      className: isMain ? _stylesModule2.default.mainSelected : null,
	      onClick: setMainClick
	    },
	    isMain ? _react2.default.createElement(_Tick2.default, { size: 14, color: '#3e5c76' }) : _react2.default.createElement(_TickOutline2.default, { size: 14, color: '#fff' }),
	    _react2.default.createElement(
	      'span',
	      null,
	      'Main'
	    )
	  );
	
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.imagePreview },
	    _react2.default.createElement(
	      _square2.default,
	      null,
	      image.data ? _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.imageContainer },
	        _react2.default.createElement('img', { src: image.data })
	      ) : _react2.default.createElement(
	        'p',
	        null,
	        'Loading image'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.nameAndButton },
	      _react2.default.createElement(
	        'p',
	        { title: image.name },
	        image.name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.actions },
	        mainDisabled ? _react2.default.createElement(
	          _Tooltip2.default,
	          { inline: true, text: 'Item must have one main image' },
	          mainButton
	        ) : mainButton,
	        _react2.default.createElement(
	          'button',
	          { onClick: removeClick },
	          _react2.default.createElement(_Cross2.default, { size: 14, color: '#fff' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Remove'
	          )
	        )
	      )
	    )
	  );
	};
	
	var ImageSelection = function (_Component) {
	  _inherits(ImageSelection, _Component);
	
	  function ImageSelection() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ImageSelection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.fileSelected = function (event) {
	      var file = event.target.files[0];
	      var reader = new FileReader();
	
	      reader.onloadend = function () {
	        var newArray = [].concat(_this.props.images, [{
	          name: file.name,
	          loading: false,
	          data: reader.result,
	          blob: file
	        }]);
	        _this.props.onChange(newArray);
	      };
	
	      reader.readAsDataURL(file);
	    }, _this.removeImage = function (index) {
	      var newArray = [].concat(_this.props.images);
	      newArray.splice(index, 1);
	      _this.props.onChange(newArray, index === _this.props.mainImageValue, index);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ImageSelection.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.container },
	      _react2.default.createElement('input', {
	        type: 'file',
	        id: _text2.default.FORMS.imagesId,
	        onChange: this.fileSelected,
	        accept: 'image/x-png,image/gif,image/jpeg',
	        value: ''
	      }),
	      _react2.default.createElement(_pillButton2.default, {
	        tag: 'label',
	        theme: 'blue',
	        htmlFor: _text2.default.FORMS.imagesId,
	        text: _text2.default.FORMS.imagesLabel
	      }),
	      _react2.default.createElement(
	        'p',
	        { className: _stylesModule2.default.amountSelectedLabel },
	        this.props.images.length === 0 ? _text2.default.FORMS.imageNoneSelected : _text2.default.FORMS.imagesXSelected.replace('{x}', this.props.images.length).replace('(s)', this.props.images.length > 1 ? 's' : '')
	      ),
	      this.props.images.length > 0 && _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.previews },
	        this.props.images.map(function (image, index) {
	          return _react2.default.createElement(ImageTile, {
	            key: image.name + '-' + index,
	            image: image,
	            isMain: _this2.props.mainImageValue === index,
	            mainDisabled: _this2.props.requiresMain && _this2.props.mainImageValue === index,
	            setMainClick: function setMainClick(event) {
	              return _this2.props.setMainImageValue({
	                target: {
	                  value: _this2.props.mainImageValue === index ? null : index
	                }
	              });
	            },
	            removeClick: function removeClick() {
	              return _this2.removeImage(index);
	            }
	          });
	        }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Select an image as the "main" image for an item and it will be the image shown in search results and the first image shown of the items page.'
	        )
	      )
	    );
	  };
	
	  return ImageSelection;
	}(_react.Component);
	
	exports.default = ImageSelection;
	module.exports = exports['default'];

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-image-selection----styles-module---container---2Uu6L","amountSelectedLabel":"src-components-contribution-form-form-components-image-selection----styles-module---amountSelectedLabel---8-A_q","previews":"src-components-contribution-form-form-components-image-selection----styles-module---previews---3EmhR","imagePreview":"src-components-contribution-form-form-components-image-selection----styles-module---imagePreview---28IdE","imageContainer":"src-components-contribution-form-form-components-image-selection----styles-module---imageContainer---15Jbg","nameAndButton":"src-components-contribution-form-form-components-image-selection----styles-module---nameAndButton---2UWNn","actions":"src-components-contribution-form-form-components-image-selection----styles-module---actions---3PFrf","mainSelected":"src-components-contribution-form-form-components-image-selection----styles-module---mainSelected---7IbUr"};

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(141);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _stageProgress = __webpack_require__(61);
	
	var _stageProgress2 = _interopRequireDefault(_stageProgress);
	
	var _formButtons = __webpack_require__(101);
	
	var _formButtons2 = _interopRequireDefault(_formButtons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var title = _ref.title,
	      subTitle = _ref.subTitle,
	      stages = _ref.stages,
	      children = _ref.children,
	      footerProps = _ref.footerProps;
	  return _react2.default.createElement(
	    'div',
	    { id: 'form-overlay', className: _stylesModule2.default.container },
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.header },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.inner },
	        _react2.default.createElement(
	          'h2',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          subTitle
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.middle },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.inner },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.split },
	          stages && _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.steps },
	            _react2.default.createElement(_stageProgress2.default, { stages: stages })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.form },
	            children
	          )
	        )
	      )
	    ),
	    footerProps && _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.footer },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.inner },
	        _react2.default.createElement(_formButtons2.default, footerProps)
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---container---2NVvT","header":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---header---3Ahi2","inner":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---inner---2wzk5","middle":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---middle---1sSz6","split":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---split---1WwYn","steps":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---steps---3ytYU","form":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---form---3iBIf","footer":"src-components-contribution-form-form-components-overlay-wrapper----styles-module---footer---3k1NU"};

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(142);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _glassData = __webpack_require__(24);
	
	var _glassData2 = _interopRequireDefault(_glassData);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _glass = __webpack_require__(129);
	
	var _glass2 = _interopRequireDefault(_glass);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _square = __webpack_require__(56);
	
	var _square2 = _interopRequireDefault(_square);
	
	var _Plus = __webpack_require__(126);
	
	var _Plus2 = _interopRequireDefault(_Plus);
	
	var _Cross = __webpack_require__(28);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectedItem = function SelectedItem(_ref) {
	  var id = _ref.id,
	      _onClick = _ref.onClick,
	      noRemove = _ref.noRemove;
	  return _react2.default.createElement(
	    'button',
	    {
	      className: _stylesModule2.default.selectedItem,
	      onClick: function onClick(event) {
	        event.preventDefault();
	        _onClick();
	      }
	    },
	    _react2.default.createElement(
	      'span',
	      null,
	      _glassData2.default.find(function (item) {
	        return item.id === id;
	      }).title
	    ),
	    !noRemove && _react2.default.createElement(_Cross2.default, { color: 'white' })
	  );
	};
	
	var ResultItem = function ResultItem(_ref2) {
	  var title = _ref2.title,
	      _onClick2 = _ref2.onClick;
	  return _react2.default.createElement(
	    'button',
	    {
	      className: _stylesModule2.default.resultItem,
	      onClick: function onClick(event) {
	        event.preventDefault();
	        _onClick2();
	      }
	    },
	    _react2.default.createElement(
	      'span',
	      null,
	      title
	    ),
	    _react2.default.createElement(_Plus2.default, { size: 12, color: 'white' })
	  );
	};
	
	var searchGlass = function searchGlass(items, searchTerm, alreadySelected) {
	  return (0, _glass2.default)(items, searchTerm).filter(function (item) {
	    return !alreadySelected.includes(item.id);
	  }).slice(0, 8);
	};
	
	var RelatedItemSelection = function (_Component) {
	  _inherits(RelatedItemSelection, _Component);
	
	  function RelatedItemSelection(props) {
	    _classCallCheck(this, RelatedItemSelection);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.setSearchTerm = function (event) {
	      return _this.setState({
	        searchTerm: event.target.value,
	        searchResults: searchGlass(_glassData2.default, event.target.value, _this.props.selectedItems)
	      });
	    };
	
	    _this.selectItem = function (id) {
	      var newSelectedItems = [].concat(_this.props.selectedItems, [id]);
	      _this.props.onChange(newSelectedItems);
	      _this.setState(function (state) {
	        return {
	          searchResults: searchGlass(_glassData2.default, state.searchTerm, newSelectedItems)
	        };
	      });
	    };
	
	    _this.deselectItem = function (id) {
	      var newSelectedItems = _this.props.selectedItems.filter(function (value) {
	        return value !== id;
	      });
	      _this.props.onChange(newSelectedItems);
	      _this.setState(function (state) {
	        return {
	          searchResults: searchGlass(_glassData2.default, state.searchTerm, newSelectedItems)
	        };
	      });
	    };
	
	    _this.state = {
	      searchTerm: '',
	      searchResults: searchGlass(_glassData2.default, '', [props.preselectedItemId])
	    };
	    return _this;
	  }
	
	  RelatedItemSelection.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        null,
	        this.props.form === 'memory' ? _text2.default.FORMS.releatedItemsMemoryDescription : _text2.default.FORMS.releatedItemsItemDescription
	      ),
	      this.props.selectedItems.length === 0 ? _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.noneSelected },
	        'No items selected. Search for some below.'
	      ) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          { className: _stylesModule2.default.selected },
	          this.props.selectedItems.map(function (id) {
	            return _react2.default.createElement(
	              'li',
	              { key: id },
	              _react2.default.createElement(SelectedItem, {
	                id: id,
	                onClick: function onClick() {
	                  return _this2.deselectItem(id);
	                },
	                noRemove: id === _this2.props.preselectedItemId
	              })
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.searchAndSelect },
	        _react2.default.createElement(_textBox2.default, {
	          id: 'itemSearch',
	          label: 'Search items',
	          placeholder: 'Search for items by name...',
	          value: this.state.searchTerm,
	          onChange: this.setSearchTerm
	        }),
	        this.state.searchResults.length === 0 || !this.state.searchTerm ? _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.noResults },
	          !this.state.searchTerm ? 'Enter a search term to see items to select.' : 'No items found matching that search term.'
	        ) : _react2.default.createElement(
	          'ul',
	          { className: _stylesModule2.default.results },
	          this.state.searchResults.map(function (_ref3) {
	            var id = _ref3.id,
	                title = _ref3.title;
	            return _react2.default.createElement(
	              'li',
	              { key: id },
	              _react2.default.createElement(ResultItem, {
	                title: title,
	                onClick: function onClick() {
	                  return _this2.selectItem(id);
	                }
	              })
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return RelatedItemSelection;
	}(_react.Component);
	
	exports.default = RelatedItemSelection;
	module.exports = exports['default'];

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-related-items-selection----styles-module---container---pZR7_","noneSelected":"src-components-contribution-form-form-components-related-items-selection----styles-module---noneSelected---2MbXF","noResults":"src-components-contribution-form-form-components-related-items-selection----styles-module---noResults---2DRtn","searchAndSelect":"src-components-contribution-form-form-components-related-items-selection----styles-module---searchAndSelect---1OLpJ","selected":"src-components-contribution-form-form-components-related-items-selection----styles-module---selected---2ZXLe","results":"src-components-contribution-form-form-components-related-items-selection----styles-module---results---Tim2s","selectedItem":"src-components-contribution-form-form-components-related-items-selection----styles-module---selectedItem---3wEoC","resultItem":"src-components-contribution-form-form-components-related-items-selection----styles-module---resultItem---1d8Jz"};

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(143);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var stages = _ref.stages;
	  return _react2.default.createElement(
	    'nav',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.title },
	      'Steps'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      stages.map(function (_ref2, index) {
	        var name = _ref2.name,
	            active = _ref2.active,
	            disabled = _ref2.disabled,
	            _onClick = _ref2.onClick;
	        return _react2.default.createElement(
	          'li',
	          { key: name },
	          _react2.default.createElement(
	            'button',
	            {
	              id: 'form-step-' + (index + 1),
	              className: active ? _stylesModule2.default.active : undefined,
	              disabled: disabled,
	              onClick: function onClick(event) {
	                event.preventDefault();
	                _onClick();
	              }
	            },
	            _react2.default.createElement(
	              'span',
	              null,
	              index + 1
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              name
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-form-components-stage-progress----styles-module---container---30UkT","title":"src-components-contribution-form-form-components-stage-progress----styles-module---title---2M6fy","active":"src-components-contribution-form-form-components-stage-progress----styles-module---active---3qi1C"};

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glassData = __webpack_require__(24);
	
	var _glassData2 = _interopRequireDefault(_glassData);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _formController = __webpack_require__(21);
	
	var _formController2 = _interopRequireDefault(_formController);
	
	var _overlayWrapper = __webpack_require__(23);
	
	var _overlayWrapper2 = _interopRequireDefault(_overlayWrapper);
	
	var _formWrapper = __webpack_require__(22);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	var _stageProgress = __webpack_require__(61);
	
	var _stageProgress2 = _interopRequireDefault(_stageProgress);
	
	var _formValidator = __webpack_require__(47);
	
	var _stage = __webpack_require__(103);
	
	var _stage2 = _interopRequireDefault(_stage);
	
	var _stage3 = __webpack_require__(104);
	
	var _stage4 = _interopRequireDefault(_stage3);
	
	var _stage5 = __webpack_require__(105);
	
	var _stage6 = _interopRequireDefault(_stage5);
	
	var _stage7 = __webpack_require__(106);
	
	var _stage8 = _interopRequireDefault(_stage7);
	
	var _stage9 = __webpack_require__(107);
	
	var _stage10 = _interopRequireDefault(_stage9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formStages = {
	  1: _stage2.default,
	  2: _stage4.default,
	  3: _stage6.default,
	  4: _stage8.default,
	  5: _stage10.default
	};
	
	var EditItemForm = function (_FormController) {
	  _inherits(EditItemForm, _FormController);
	
	  function EditItemForm(props) {
	    _classCallCheck(this, EditItemForm);
	
	    var _this = _possibleConstructorReturn(this, _FormController.call(this, props, [
	    // Stage One
	    'itemNameValue', 'itemDescValue',
	
	    // Stage Two
	    'locationValue', 'yearValue', 'designerValue', 'productionMethodValue', 'productionLocationValue', 'tablewareTypeValue', 'patternNumberValue', 'colorValue',
	
	    // Stage Three
	    'mainImageValue', 'images',
	
	    // Stage Four
	    'relatedItems',
	
	    // Stage Five
	    'emailValue'], null, 5));
	
	    _this.moveToStageOne = function () {
	      return _this.setState({ stage: 1 });
	    };
	
	    _this.moveToStageTwo = function () {
	      return _this.setState({ stage: 2 });
	    };
	
	    _this.moveToStageThree = function () {
	      return _this.setState({ stage: 3 });
	    };
	
	    _this.moveToStageFour = function () {
	      return _this.setState({ stage: 4 });
	    };
	
	    _this.editFormValid = function () {
	      var fields = _this.extractFields();
	      var item = _glassData2.default.find(function (_ref) {
	        var id = _ref.id;
	        return id === _this.props.itemId;
	      });
	
	      // Check that at least one value has been edited
	      return !!fields.email && (0, _formValidator.validateEmail)(fields.email) && !!fields.itemName && (fields.itemName !== item.title || fields.itemDesc !== item.description || fields.location !== item.data.location || fields.year !== item.data.year || fields.designer !== item.data.designer || fields.productionMethod !== item.data.productionMethod || fields.productionLocation !== item.data.productionLocation || fields.tablewareType !== item.data.tablewareType || fields.patternNumber !== item.data.patternNumber || fields.color !== item.data.colour || fields.relatedItems !== item.relatedItems.join(',') || fields.mainImage !== null && fields.mainImage !== '' || _this.state.images.length > 0);
	    };
	
	    _this.editFormValidationMessage = function () {
	      var fields = _this.extractFields();
	
	      if (!fields.email) {
	        return 'Please enter your email address';
	      } else if (!(0, _formValidator.validateEmail)(fields.email)) {
	        return _text2.default.FORMS.invalidEmailAddress;
	      } else if (!fields.itemName) {
	        return 'You must provide an item name';
	      } else if (!_this.editFormValid()) {
	        return 'You have not changed any values';
	      }
	    };
	
	    _this.handleSetImages = function (images, removedMain, removedIndex) {
	      if (removedMain) {
	        if (!_this.hasExistingImage) {
	          // If the user just removed the image with was selected as "Main" then set
	          // the first image as Main if the item currently has no images
	          _this.setMainImageValue({ target: { value: 0 } });
	        } else {
	          // If the user just removed the image with was selected as "Main" then set
	          // the value as null if the item currently has some images
	          _this.setMainImageValue({ target: { value: null } });
	        }
	      } else {
	        // If the user just added the first image and the item currently has no
	        // images then make the first image the "Main"
	        if (_this.state.images.length === 0 && images.length === 1 && !_this.hasExistingImage) {
	          _this.setMainImageValue({ target: { value: 0 } });
	        } else {
	          // If the index of the removed image was less than the index of the selected
	          // main then we need to decrement the main index value
	          if (removedIndex < _this.state.mainImageValue) {
	            _this.setMainImageValue({
	              target: { value: _this.state.mainImageValue - 1 }
	            });
	          }
	        }
	      }
	      // Pass up to the actual setImages function
	      _this.setImages(images);
	    };
	
	    _this.submitWrapper = function () {
	      // Only send values which have changed when compared to the original item
	      var item = _glassData2.default.find(function (_ref2) {
	        var id = _ref2.id;
	        return id === _this.props.itemId;
	      });
	
	      // Fields are all text inputs indicated by ending in the word "Value"
	      var fields = _this.extractFields();
	
	      // TODO: Could probably automate these checks if the naming was more consistent
	      if (fields.itemName === item.title) {
	        delete fields.itemName;
	      }
	      if (fields.itemDesc === item.description) {
	        delete fields.itemDesc;
	      }
	      if (fields.location === item.data.location) {
	        delete fields.location;
	      }
	      if (fields.year === item.data.year) {
	        delete fields.year;
	      }
	      if (fields.designer === item.data.designer) {
	        delete fields.designer;
	      }
	      if (fields.productionMethod === item.data.productionMethod) {
	        delete fields.productionMethod;
	      }
	      if (fields.productionLocation === item.data.productionLocation) {
	        delete fields.productionLocation;
	      }
	      if (fields.tablewareType === item.data.tablewareType) {
	        delete fields.tablewareType;
	      }
	      if (fields.patternNumber === item.data.patternNumber) {
	        delete fields.patternNumber;
	      }
	      if (fields.color === item.data.colour) {
	        delete fields.color;
	      }
	      if (fields.relatedItems === item.relatedItems.join(',')) {
	        delete fields.relatedItems;
	      }
	      if (!fields.mainImage) {
	        delete fields.mainImage;
	      }
	
	      _this.props.submitForm({ fields: fields, images: _this.state.images }, _this.state);
	    };
	
	    _extends(_this.state, {
	      stage: _this.state.stage || 1
	    });
	
	    _this.hasExistingImage = !!_glassData2.default.find(function (_ref3) {
	      var id = _ref3.id;
	      return id === props.itemId;
	    }).mainImage;
	
	    if (!props.recoveryState) {
	      // Load details of item to fill form values
	      var item = _glassData2.default.find(function (_ref4) {
	        var id = _ref4.id;
	        return id === props.itemId;
	      });
	      _this.itemType = item.data.glassType;
	
	      // Stage One
	      _this.state.itemNameValue = item.title;
	      _this.state.itemDescValue = item.description;
	
	      // Stage Two
	      _this.state.locationValue = item.data.location;
	      _this.state.yearValue = item.data.year;
	      _this.state.designerValue = item.data.designer;
	      _this.state.productionMethodValue = item.data.productionMethod;
	      _this.state.productionLocationValue = item.data.productionLocation;
	
	      _this.state.tablewareTypeValue = item.data.tablewareType;
	      _this.state.patternNumberValue = item.data.patternNumber;
	      _this.state.colorValue = item.data.colour;
	
	      // Stage Three
	      //  - Existing images not yet loaded
	
	      // Stage Four
	      _this.state.relatedItems = item.relatedItems;
	    }
	    return _this;
	  }
	
	  EditItemForm.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _overlayWrapper2.default,
	      {
	        title: _text2.default.CONTRIBUTION_FORMS.EDIT_ITEM.title,
	        subTitle: _text2.default.CONTRIBUTION_FORMS.EDIT_ITEM.subTitle,
	        footerProps: this.getFooterProps(this.submitWrapper, !this.editFormValid(), this.editFormValidationMessage()),
	        stages: [{
	          name: 'Description',
	          active: this.state.stage === 1,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 1 });
	          }
	        }, {
	          name: 'Details',
	          active: this.state.stage === 2,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 2 });
	          }
	        }, {
	          name: 'Images',
	          active: this.state.stage === 3,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 3 });
	          }
	        }, {
	          name: 'Related',
	          active: this.state.stage === 4,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 4 });
	          }
	        }, {
	          name: 'Finish',
	          active: this.state.stage === 5,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 5 });
	          }
	        }]
	      },
	      _react2.default.createElement(
	        _formWrapper2.default,
	        { nested: true },
	        _react2.default.createElement(formStages[this.state.stage], {
	          // Stage One values
	          itemNameValue: this.state.itemNameValue,
	          setItemNameValue: this.setItemNameValue,
	          itemTypeValue: this.itemType,
	          itemDescValue: this.state.itemDescValue,
	          setItemDescValue: this.setItemDescValue,
	
	          // Stage Two values
	          locationValue: this.state.locationValue,
	          setLocationValue: this.setLocationValue,
	          yearValue: this.state.yearValue,
	          setYearValue: this.setYearValue,
	          productionMethodValue: this.state.productionMethodValue,
	          setProductionMethodValue: this.setProductionMethodValue,
	          productionLocationValue: this.state.productionLocationValue,
	          setProductionLocationValue: this.setProductionLocationValue,
	          tablewareTypeValue: this.state.tablewareTypeValue,
	          setTablewareTypeValue: this.setTablewareTypeValue,
	          patternNumberValue: this.state.patternNumberValue,
	          setPatternNumberValue: this.setPatternNumberValue,
	          colorValue: this.state.colorValue,
	          setColorValue: this.setColorValue,
	          designerValue: this.state.designerValue,
	          setDesignerValue: this.setDesignerValue,
	
	          // Stage Three values
	          images: this.state.images,
	          setImages: this.handleSetImages,
	          requiresMainImage: !this.hasExistingImage,
	          mainImageValue: this.state.mainImageValue,
	          setMainImageValue: this.setMainImageValue,
	
	          // Stage Four values
	          relatedItems: this.state.relatedItems,
	          setRelatedItems: this.setRelatedItems,
	
	          // Stage Five
	          emailValue: this.state.emailValue,
	          setEmailValue: this.setEmailValue,
	          formValid: this.editFormValid(),
	          validationMessage: this.editFormValidationMessage()
	        })
	      )
	    );
	  };
	
	  return EditItemForm;
	}(_formController2.default);
	
	exports.default = EditItemForm;
	module.exports = exports['default'];

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	var _textArea = __webpack_require__(27);
	
	var _textArea2 = _interopRequireDefault(_textArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var itemNameValue = _ref.itemNameValue,
	      setItemNameValue = _ref.setItemNameValue,
	      itemDescValue = _ref.itemDescValue,
	      setItemDescValue = _ref.setItemDescValue;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_textBox2.default, {
	      required: true,
	      id: _text2.default.FORMS.itemNameId,
	      label: _text2.default.FORMS.itemNameLabel,
	      placeholder: _text2.default.FORMS.itemNamePlaceholder,
	      value: itemNameValue,
	      onChange: setItemNameValue
	    }),
	    _react2.default.createElement(_textArea2.default, {
	      id: _text2.default.FORMS.itemDescId,
	      label: _text2.default.FORMS.itemDescLabel,
	      placeholder: _text2.default.FORMS.itemDescPlaceholder,
	      value: itemDescValue,
	      onChange: setItemDescValue
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	var _dropDown = __webpack_require__(26);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var itemTypeValue = _ref.itemTypeValue,
	      locationValue = _ref.locationValue,
	      setLocationValue = _ref.setLocationValue,
	      yearValue = _ref.yearValue,
	      setYearValue = _ref.setYearValue,
	      designerValue = _ref.designerValue,
	      setDesignerValue = _ref.setDesignerValue,
	      productionMethodValue = _ref.productionMethodValue,
	      setProductionMethodValue = _ref.setProductionMethodValue,
	      productionLocationValue = _ref.productionLocationValue,
	      setProductionLocationValue = _ref.setProductionLocationValue,
	      tablewareTypeValue = _ref.tablewareTypeValue,
	      setTablewareTypeValue = _ref.setTablewareTypeValue,
	      patternNumberValue = _ref.patternNumberValue,
	      setPatternNumberValue = _ref.setPatternNumberValue,
	      colorValue = _ref.colorValue,
	      setColorValue = _ref.setColorValue;
	  return _react2.default.createElement(
	    'div',
	    null,
	    itemTypeValue === 'WINDOW' && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.locationId,
	        label: _text2.default.FORMS.locationLabel,
	        placeholder: _text2.default.FORMS.locationPlaceholder,
	        value: locationValue,
	        onChange: setLocationValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.yearId,
	        label: _text2.default.FORMS.yearLabel,
	        placeholder: _text2.default.FORMS.yearPlaceholder,
	        value: yearValue,
	        onChange: setYearValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.designerId,
	        label: _text2.default.FORMS.designerLabel,
	        placeholder: _text2.default.FORMS.designerPlaceholder,
	        value: designerValue,
	        onChange: setDesignerValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionMethodId,
	        label: _text2.default.FORMS.productionMethodLabel,
	        options: _text2.default.FORMS.productionMethodWindowOptions,
	        value: productionMethodValue,
	        onChange: setProductionMethodValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionLocationId,
	        label: _text2.default.FORMS.productionLocationLabel,
	        options: _text2.default.FORMS.productionLocationOptions,
	        value: productionLocationValue,
	        onChange: setProductionLocationValue
	      })
	    ),
	    itemTypeValue === 'TABLEWARE' && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.tablewareTypeId,
	        label: _text2.default.FORMS.tablewareTypeLabel,
	        placeholder: _text2.default.FORMS.tablewareTypePlaceholder,
	        value: tablewareTypeValue,
	        onChange: setTablewareTypeValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionMethodId,
	        label: _text2.default.FORMS.productionMethodLabel,
	        options: _text2.default.FORMS.productionMethodTablewareOptions,
	        value: productionMethodValue,
	        onChange: setProductionMethodValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.patternNumberId,
	        label: _text2.default.FORMS.patternNumberLabel,
	        placeholder: _text2.default.FORMS.patternNumberPlaceholder,
	        value: patternNumberValue,
	        onChange: setPatternNumberValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.colorId,
	        label: _text2.default.FORMS.colorLabel,
	        placeholder: _text2.default.FORMS.colorPlaceholder,
	        value: colorValue,
	        onChange: setColorValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.designerId,
	        label: _text2.default.FORMS.designerLabel,
	        placeholder: _text2.default.FORMS.designerPlaceholder,
	        value: designerValue,
	        onChange: setDesignerValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.yearId,
	        label: _text2.default.FORMS.yearLabel,
	        placeholder: _text2.default.FORMS.yearPlaceholder,
	        value: yearValue,
	        onChange: setYearValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionLocationId,
	        label: _text2.default.FORMS.productionLocationLabel,
	        options: _text2.default.FORMS.productionLocationOptions,
	        value: productionLocationValue,
	        onChange: setProductionLocationValue
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imageSelection = __webpack_require__(40);
	
	var _imageSelection2 = _interopRequireDefault(_imageSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var images = _ref.images,
	      setImages = _ref.setImages,
	      requiresMainImage = _ref.requiresMainImage,
	      mainImageValue = _ref.mainImageValue,
	      setMainImageValue = _ref.setMainImageValue;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_imageSelection2.default, {
	      images: images,
	      onChange: setImages,
	      requiresMain: requiresMainImage,
	      setMainImageValue: setMainImageValue,
	      mainImageValue: mainImageValue
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _relatedItemsSelection = __webpack_require__(41);
	
	var _relatedItemsSelection2 = _interopRequireDefault(_relatedItemsSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var relatedItems = _ref.relatedItems,
	      setRelatedItems = _ref.setRelatedItems;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_relatedItemsSelection2.default, {
	      selectedItems: relatedItems,
	      onChange: setRelatedItems
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _emailInput = __webpack_require__(20);
	
	var _emailInput2 = _interopRequireDefault(_emailInput);
	
	var _errorMessage = __webpack_require__(17);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var emailValue = _ref.emailValue,
	      setEmailValue = _ref.setEmailValue,
	      formValid = _ref.formValid,
	      validationMessage = _ref.validationMessage;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_emailInput2.default, { emailValue: emailValue, setEmailValue: setEmailValue }),
	    !formValid && _react2.default.createElement(_errorMessage2.default, {
	      title: 'Form not complete for submission',
	      message: validationMessage
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _formController = __webpack_require__(21);
	
	var _formController2 = _interopRequireDefault(_formController);
	
	var _overlayWrapper = __webpack_require__(23);
	
	var _overlayWrapper2 = _interopRequireDefault(_overlayWrapper);
	
	var _formWrapper = __webpack_require__(22);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	var _textArea = __webpack_require__(27);
	
	var _textArea2 = _interopRequireDefault(_textArea);
	
	var _emailInput = __webpack_require__(20);
	
	var _emailInput2 = _interopRequireDefault(_emailInput);
	
	var _errorMessage = __webpack_require__(17);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GeneralForm = function (_FormController) {
	  _inherits(GeneralForm, _FormController);
	
	  function GeneralForm(props) {
	    _classCallCheck(this, GeneralForm);
	
	    return _possibleConstructorReturn(this, _FormController.call(this, props, ['itemIdValue', 'infoValue', 'emailValue'], ['infoValue', 'emailValue'], 2));
	  }
	
	  GeneralForm.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.itemId && !this.props.recoveryState) {
	      this.setItemIdValue({ target: { value: this.props.itemId } });
	    }
	  };
	
	  GeneralForm.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        closeForm = _props.closeForm,
	        secondaryButtonIsBack = _props.secondaryButtonIsBack,
	        clearForm = _props.clearForm;
	
	    return _react2.default.createElement(
	      _overlayWrapper2.default,
	      {
	        title: _text2.default.CONTRIBUTION_FORMS.GENERAL_INFORMATION.title,
	        subTitle: _text2.default.CONTRIBUTION_FORMS.GENERAL_INFORMATION.subTitle,
	        footerProps: this.getFooterProps(),
	        stages: [{
	          name: 'Details',
	          active: this.state.stage === 1,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 1 });
	          }
	        }, {
	          name: 'Finish',
	          active: this.state.stage === 2,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 2 });
	          }
	        }]
	      },
	      _react2.default.createElement(
	        _formWrapper2.default,
	        null,
	        this.state.stage === 1 && _react2.default.createElement(_textArea2.default, {
	          required: true,
	          id: _text2.default.FORMS.infoId,
	          label: _text2.default.FORMS.infoLabel,
	          placeholder: _text2.default.FORMS.infoPlaceholder,
	          value: this.state.infoValue,
	          onChange: this.setInfoValue
	        }),
	        this.state.stage === 2 && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_emailInput2.default, {
	            emailValue: this.state.emailValue,
	            setEmailValue: this.setEmailValue
	          }),
	          !this.state.formValid && _react2.default.createElement(_errorMessage2.default, {
	            title: 'Form not complete for submission',
	            message: this.validationMessage(this.state)
	          })
	        )
	      )
	    );
	  };
	
	  return GeneralForm;
	}(_formController2.default);
	
	exports.default = GeneralForm;
	module.exports = exports['default'];

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glassData = __webpack_require__(24);
	
	var _glassData2 = _interopRequireDefault(_glassData);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _formController = __webpack_require__(21);
	
	var _formController2 = _interopRequireDefault(_formController);
	
	var _overlayWrapper = __webpack_require__(23);
	
	var _overlayWrapper2 = _interopRequireDefault(_overlayWrapper);
	
	var _formWrapper = __webpack_require__(22);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	var _imageSelection = __webpack_require__(40);
	
	var _imageSelection2 = _interopRequireDefault(_imageSelection);
	
	var _emailInput = __webpack_require__(20);
	
	var _emailInput2 = _interopRequireDefault(_emailInput);
	
	var _errorMessage = __webpack_require__(17);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageForm = function (_FormController) {
	  _inherits(ImageForm, _FormController);
	
	  function ImageForm(props) {
	    _classCallCheck(this, ImageForm);
	
	    var _this = _possibleConstructorReturn(this, _FormController.call(this, props, ['images', 'emailValue', 'mainImageValue'], ['images', 'emailValue'], 2));
	
	    _this.handleSetImages = function (images, removedMain, removedIndex) {
	      if (removedMain) {
	        if (!_this.hasExistingImage) {
	          // If the user just removed the image with was selected as "Main" then set
	          // the first image as Main if the item currently has no images
	          _this.setMainImageValue({ target: { value: 0 } });
	        } else {
	          // If the user just removed the image with was selected as "Main" then set
	          // the value as null if the item currently has some images
	          _this.setMainImageValue({ target: { value: null } });
	        }
	      } else {
	        // If the user just added the first image and the item currently has no
	        // images then make the first image the "Main"
	        if (_this.state.images.length === 0 && images.length === 1 && !_this.hasExistingImage) {
	          _this.setMainImageValue({ target: { value: 0 } });
	        } else {
	          // If the index of the removed image was less than the index of the selected
	          // main then we need to decrement the main index value
	          if (removedIndex < _this.state.mainImageValue) {
	            _this.setMainImageValue({
	              target: { value: _this.state.mainImageValue - 1 }
	            });
	          }
	        }
	      }
	      // Pass up to the actual setImages function
	      _this.setImages(images);
	    };
	
	    _this.hasExistingImage = !!_glassData2.default.find(function (_ref) {
	      var id = _ref.id;
	      return id === props.itemId;
	    }).mainImage;
	    return _this;
	  }
	
	  ImageForm.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        closeForm = _props.closeForm,
	        secondaryButtonIsBack = _props.secondaryButtonIsBack,
	        clearForm = _props.clearForm;
	
	    return _react2.default.createElement(
	      _overlayWrapper2.default,
	      {
	        title: _text2.default.CONTRIBUTION_FORMS.ADD_IMAGES.title,
	        subTitle: _text2.default.CONTRIBUTION_FORMS.ADD_IMAGES.subTitle,
	        footerProps: this.getFooterProps(),
	        stages: [{
	          name: 'New Images',
	          active: this.state.stage === 1,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 1 });
	          }
	        }, {
	          name: 'Review',
	          active: this.state.stage === 2,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 2 });
	          }
	        }]
	      },
	      _react2.default.createElement(
	        _formWrapper2.default,
	        null,
	        this.state.stage === 1 && _react2.default.createElement(_imageSelection2.default, {
	          images: this.state.images,
	          onChange: this.handleSetImages,
	          requiresMain: !this.hasExistingImage,
	          setMainImageValue: this.setMainImageValue,
	          mainImageValue: this.state.mainImageValue
	        }),
	        this.state.stage === 2 && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_emailInput2.default, {
	            emailValue: this.state.emailValue,
	            setEmailValue: this.setEmailValue
	          }),
	          !this.state.formValid && _react2.default.createElement(_errorMessage2.default, {
	            title: 'Form not complete for submission',
	            message: this.validationMessage(this.state)
	          })
	        )
	      )
	    );
	  };
	
	  return ImageForm;
	}(_formController2.default);
	
	exports.default = ImageForm;
	module.exports = exports['default'];

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _formController = __webpack_require__(21);
	
	var _formController2 = _interopRequireDefault(_formController);
	
	var _overlayWrapper = __webpack_require__(23);
	
	var _overlayWrapper2 = _interopRequireDefault(_overlayWrapper);
	
	var _formWrapper = __webpack_require__(22);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	var _textArea = __webpack_require__(27);
	
	var _textArea2 = _interopRequireDefault(_textArea);
	
	var _dropDown = __webpack_require__(26);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _relatedItemsSelection = __webpack_require__(41);
	
	var _relatedItemsSelection2 = _interopRequireDefault(_relatedItemsSelection);
	
	var _emailInput = __webpack_require__(20);
	
	var _emailInput2 = _interopRequireDefault(_emailInput);
	
	var _errorMessage = __webpack_require__(17);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MemoryForm = function (_FormController) {
	  _inherits(MemoryForm, _FormController);
	
	  function MemoryForm(props) {
	    _classCallCheck(this, MemoryForm);
	
	    return _possibleConstructorReturn(this, _FormController.call(this, props, ['nameValue', 'emailValue', 'memoryValue', 'personTypeValue', 'relatedItems'], ['nameValue', 'emailValue', 'memoryValue'], 3));
	  }
	
	  MemoryForm.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.itemId && !this.props.recoveryState) {
	      this.setRelatedItems([this.props.itemId]);
	    }
	  };
	
	  MemoryForm.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _overlayWrapper2.default,
	      {
	        title: _text2.default.CONTRIBUTION_FORMS.ADD_MEMORY.title,
	        subTitle: _text2.default.CONTRIBUTION_FORMS.ADD_MEMORY.subTitle,
	        footerProps: this.getFooterProps(),
	        stages: [{
	          name: 'Memory',
	          active: this.state.stage === 1,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 1 });
	          }
	        }, {
	          name: 'Related Items',
	          active: this.state.stage === 2,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 2 });
	          }
	        }, {
	          name: 'Finish',
	          active: this.state.stage === 3,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 3 });
	          }
	        }]
	      },
	      _react2.default.createElement(
	        _formWrapper2.default,
	        null,
	        this.state.stage === 1 && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_textBox2.default, {
	            required: true,
	            id: _text2.default.FORMS.nameId,
	            label: _text2.default.FORMS.nameLabel,
	            placeholder: _text2.default.FORMS.namePlaceholder,
	            value: this.state.nameValue,
	            onChange: this.setNameValue
	          }),
	          _react2.default.createElement(_dropDown2.default, {
	            id: 'personType',
	            label: 'Your association with Whitefriars',
	            selectedValue: this.state.personTypeValue,
	            onChange: this.setPersonTypeValue,
	            options: [{ text: 'Select your relation to Whitefriars...', value: '' }, { text: 'Staff', value: 'STAFF' }, { text: 'Collectors', value: 'COLLECTOR' }, { text: 'Staff Relatives', value: 'STAFF_RELATIVE' }, { text: 'Other', value: 'OTHER' }]
	          }),
	          _react2.default.createElement(_textArea2.default, {
	            required: true,
	            id: _text2.default.FORMS.memoryId,
	            label: _text2.default.FORMS.memoryLabel,
	            placeholder: _text2.default.FORMS.memoryPlaceholder,
	            value: this.state.memoryValue,
	            onChange: this.setMemoryValue
	          })
	        ),
	        this.state.stage === 2 && _react2.default.createElement(_relatedItemsSelection2.default, {
	          preselectedItemId: this.props.itemId,
	          selectedItems: this.state.relatedItems,
	          onChange: this.setRelatedItems
	        }),
	        this.state.stage === 3 && _react2.default.createElement(
	          _react.Fragment,
	          null,
	          _react2.default.createElement(_emailInput2.default, {
	            emailValue: this.state.emailValue,
	            setEmailValue: this.setEmailValue
	          }),
	          !this.state.formValid && _react2.default.createElement(_errorMessage2.default, {
	            title: 'Form not complete for submission',
	            message: this.validationMessage(this.state)
	          })
	        )
	      )
	    );
	  };
	
	  return MemoryForm;
	}(_formController2.default);
	
	exports.default = MemoryForm;
	module.exports = exports['default'];

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _formController = __webpack_require__(21);
	
	var _formController2 = _interopRequireDefault(_formController);
	
	var _overlayWrapper = __webpack_require__(23);
	
	var _overlayWrapper2 = _interopRequireDefault(_overlayWrapper);
	
	var _formWrapper = __webpack_require__(22);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	var _formValidator = __webpack_require__(47);
	
	var _stage = __webpack_require__(112);
	
	var _stage2 = _interopRequireDefault(_stage);
	
	var _stage3 = __webpack_require__(113);
	
	var _stage4 = _interopRequireDefault(_stage3);
	
	var _stage5 = __webpack_require__(114);
	
	var _stage6 = _interopRequireDefault(_stage5);
	
	var _stage7 = __webpack_require__(115);
	
	var _stage8 = _interopRequireDefault(_stage7);
	
	var _stage9 = __webpack_require__(116);
	
	var _stage10 = _interopRequireDefault(_stage9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formStages = {
	  1: _stage2.default,
	  2: _stage4.default,
	  3: _stage6.default,
	  4: _stage8.default,
	  5: _stage10.default
	};
	
	var NewItemForm = function (_FormController) {
	  _inherits(NewItemForm, _FormController);
	
	  function NewItemForm(props) {
	    _classCallCheck(this, NewItemForm);
	
	    var _this = _possibleConstructorReturn(this, _FormController.call(this, props, [
	    // Stage One
	    'itemNameValue', 'itemTypeValue', 'itemDescValue', 'emailValue',
	
	    // Stage Two
	    'locationValue', 'yearValue', 'designerValue', 'productionMethodValue', 'productionLocationValue', 'tablewareTypeValue', 'patternNumberValue', 'colorValue',
	
	    // Stage Three
	    'mainImageValue', 'images',
	
	    // Stage Four
	    'relatedItems'], null, 5));
	
	    _this.handleSetImages = function (images, removedMain, removedIndex) {
	      if (removedMain) {
	        // If the user just removed the image with was selected as "Main" then set
	        // the first image as Main if the item currently has no images
	        _this.setMainImageValue({ target: { value: 0 } });
	      } else {
	        // If the user just added the first image and the item currently has no
	        // images then make the first image the "Main"
	        if (_this.state.images.length === 0 && images.length === 1) {
	          _this.setMainImageValue({ target: { value: 0 } });
	        } else {
	          // If the index of the removed image was less than the index of the selected
	          // main then we need to decrement the main index value
	          if (removedIndex < _this.state.mainImageValue) {
	            _this.setMainImageValue({
	              target: { value: _this.state.mainImageValue - 1 }
	            });
	          }
	        }
	      }
	      // Pass up to the actual setImages function
	      _this.setImages(images);
	    };
	
	    _this.newFormValid = function () {
	      var fields = _this.extractFields();
	
	      // Check that at least required fields are input
	      return !!fields.email && (0, _formValidator.validateEmail)(fields.email) && fields.itemName !== '' && fields.itemType !== '';
	    };
	
	    _this.newFormValidationMessage = function () {
	      var fields = _this.extractFields();
	
	      if (!fields.email) {
	        return 'Please enter your email address';
	      } else if (!(0, _formValidator.validateEmail)(fields.email)) {
	        return _text2.default.FORMS.invalidEmailAddress;
	      } else if (!_this.newFormValid()) {
	        return 'Please provide at least the items name and type';
	      }
	    };
	
	    _extends(_this.state, {
	      stage: _this.state.stage || 1
	    });
	    return _this;
	  }
	
	  NewItemForm.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _overlayWrapper2.default,
	      {
	        title: _text2.default.CONTRIBUTION_FORMS.NEW_ITEM.title,
	        subTitle: _text2.default.CONTRIBUTION_FORMS.NEW_ITEM.subTitle,
	        footerProps: this.getFooterProps(null, !this.newFormValid(), this.newFormValidationMessage()),
	        stages: [{
	          name: 'Description',
	          active: this.state.stage === 1,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 1 });
	          }
	        }, {
	          name: 'Details',
	          active: this.state.stage === 2,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 2 });
	          }
	        }, {
	          name: 'Images',
	          active: this.state.stage === 3,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 3 });
	          }
	        }, {
	          name: 'Related',
	          active: this.state.stage === 4,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 4 });
	          }
	        }, {
	          name: 'Finish',
	          active: this.state.stage === 5,
	          onClick: function onClick() {
	            return _this2.setState({ stage: 5 });
	          }
	        }]
	      },
	      _react2.default.createElement(
	        _formWrapper2.default,
	        { nested: true },
	        _react2.default.createElement(formStages[this.state.stage], {
	          // Stage One values
	          itemNameValue: this.state.itemNameValue,
	          setItemNameValue: this.setItemNameValue,
	          itemTypeValue: this.state.itemTypeValue,
	          setItemTypeValue: this.setItemTypeValue,
	          itemDescValue: this.state.itemDescValue,
	          setItemDescValue: this.setItemDescValue,
	
	          // Stage Two values
	          locationValue: this.state.locationValue,
	          setLocationValue: this.setLocationValue,
	          yearValue: this.state.yearValue,
	          setYearValue: this.setYearValue,
	          productionMethodValue: this.state.productionMethodValue,
	          setProductionMethodValue: this.setProductionMethodValue,
	          productionLocationValue: this.state.productionLocationValue,
	          setProductionLocationValue: this.setProductionLocationValue,
	          tablewareTypeValue: this.state.tablewareTypeValue,
	          setTablewareTypeValue: this.setTablewareTypeValue,
	          patternNumberValue: this.state.patternNumberValue,
	          setPatternNumberValue: this.setPatternNumberValue,
	          colorValue: this.state.colorValue,
	          setColorValue: this.setColorValue,
	          designerValue: this.state.designerValue,
	          setDesignerValue: this.setDesignerValue,
	
	          // Stage Three values
	          images: this.state.images,
	          setImages: this.handleSetImages,
	          mainImageValue: this.state.mainImageValue,
	          setMainImageValue: this.setMainImageValue,
	
	          // Stage Four values
	          relatedItems: this.state.relatedItems,
	          setRelatedItems: this.setRelatedItems,
	
	          // Stage Five
	          emailValue: this.state.emailValue,
	          setEmailValue: this.setEmailValue,
	          formValid: this.newFormValid(),
	          validationMessage: this.newFormValidationMessage()
	        })
	      )
	    );
	  };
	
	  return NewItemForm;
	}(_formController2.default);
	
	exports.default = NewItemForm;
	module.exports = exports['default'];

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	var _textArea = __webpack_require__(27);
	
	var _textArea2 = _interopRequireDefault(_textArea);
	
	var _dropDown = __webpack_require__(26);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var itemNameValue = _ref.itemNameValue,
	      setItemNameValue = _ref.setItemNameValue,
	      itemTypeValue = _ref.itemTypeValue,
	      setItemTypeValue = _ref.setItemTypeValue,
	      itemDescValue = _ref.itemDescValue,
	      setItemDescValue = _ref.setItemDescValue;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_textBox2.default, {
	      required: true,
	      id: _text2.default.FORMS.itemNameId,
	      label: _text2.default.FORMS.itemNameLabel,
	      placeholder: _text2.default.FORMS.itemNamePlaceholder,
	      value: itemNameValue,
	      onChange: setItemNameValue
	    }),
	    _react2.default.createElement(_dropDown2.default, {
	      required: true,
	      id: _text2.default.FORMS.itemTypeId,
	      label: _text2.default.FORMS.itemTypeLabel,
	      selectedValue: itemTypeValue,
	      onChange: setItemTypeValue,
	      options: [{ text: _text2.default.FORMS.itemTypePlaceholder, value: '' }, { text: 'Tableware Glass', value: 'TABLEWARE' }, { text: 'Stained Glass Window', value: 'WINDOW' }]
	    }),
	    _react2.default.createElement(_textArea2.default, {
	      id: _text2.default.FORMS.itemDescId,
	      label: _text2.default.FORMS.itemDescLabel,
	      placeholder: _text2.default.FORMS.itemDescPlaceholder,
	      value: itemDescValue,
	      onChange: setItemDescValue
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _textBox = __webpack_require__(13);
	
	var _textBox2 = _interopRequireDefault(_textBox);
	
	var _dropDown = __webpack_require__(26);
	
	var _dropDown2 = _interopRequireDefault(_dropDown);
	
	var _errorMessage = __webpack_require__(17);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var itemTypeValue = _ref.itemTypeValue,
	      setItemTypeValue = _ref.setItemTypeValue,
	      locationValue = _ref.locationValue,
	      setLocationValue = _ref.setLocationValue,
	      yearValue = _ref.yearValue,
	      setYearValue = _ref.setYearValue,
	      designerValue = _ref.designerValue,
	      setDesignerValue = _ref.setDesignerValue,
	      productionMethodValue = _ref.productionMethodValue,
	      setProductionMethodValue = _ref.setProductionMethodValue,
	      productionLocationValue = _ref.productionLocationValue,
	      setProductionLocationValue = _ref.setProductionLocationValue,
	      tablewareTypeValue = _ref.tablewareTypeValue,
	      setTablewareTypeValue = _ref.setTablewareTypeValue,
	      patternNumberValue = _ref.patternNumberValue,
	      setPatternNumberValue = _ref.setPatternNumberValue,
	      colorValue = _ref.colorValue,
	      setColorValue = _ref.setColorValue;
	  return _react2.default.createElement(
	    'div',
	    null,
	    !itemTypeValue && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_errorMessage2.default, { message: 'You must select the item\'s type before being able to enter it\'s details.' }),
	      _react2.default.createElement(_dropDown2.default, {
	        required: true,
	        id: _text2.default.FORMS.itemTypeId,
	        label: _text2.default.FORMS.itemTypeLabel,
	        selectedValue: itemTypeValue,
	        onChange: setItemTypeValue,
	        options: [{ text: _text2.default.FORMS.itemTypePlaceholder, value: '' }, { text: 'Tableware Glass', value: 'TABLEWARE' }, { text: 'Stained Glass Window', value: 'WINDOW' }]
	      })
	    ),
	    itemTypeValue === 'WINDOW' && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.locationId,
	        label: _text2.default.FORMS.locationLabel,
	        placeholder: _text2.default.FORMS.locationPlaceholder,
	        value: locationValue,
	        onChange: setLocationValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.yearId,
	        label: _text2.default.FORMS.yearLabel,
	        placeholder: _text2.default.FORMS.yearPlaceholder,
	        value: yearValue,
	        onChange: setYearValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.designerId,
	        label: _text2.default.FORMS.designerLabel,
	        placeholder: _text2.default.FORMS.designerPlaceholder,
	        value: designerValue,
	        onChange: setDesignerValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionMethodId,
	        label: _text2.default.FORMS.productionMethodLabel,
	        options: _text2.default.FORMS.productionMethodWindowOptions,
	        value: productionMethodValue,
	        onChange: setProductionMethodValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionLocationId,
	        label: _text2.default.FORMS.productionLocationLabel,
	        options: _text2.default.FORMS.productionLocationOptions,
	        value: productionLocationValue,
	        onChange: setProductionLocationValue
	      })
	    ),
	    itemTypeValue === 'TABLEWARE' && _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.tablewareTypeId,
	        label: _text2.default.FORMS.tablewareTypeLabel,
	        placeholder: _text2.default.FORMS.tablewareTypePlaceholder,
	        value: tablewareTypeValue,
	        onChange: setTablewareTypeValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionMethodId,
	        label: _text2.default.FORMS.productionMethodLabel,
	        options: _text2.default.FORMS.productionMethodTablewareOptions,
	        value: productionMethodValue,
	        onChange: setProductionMethodValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.patternNumberId,
	        label: _text2.default.FORMS.patternNumberLabel,
	        placeholder: _text2.default.FORMS.patternNumberPlaceholder,
	        value: patternNumberValue,
	        onChange: setPatternNumberValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.colorId,
	        label: _text2.default.FORMS.colorLabel,
	        placeholder: _text2.default.FORMS.colorPlaceholder,
	        value: colorValue,
	        onChange: setColorValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.designerId,
	        label: _text2.default.FORMS.designerLabel,
	        placeholder: _text2.default.FORMS.designerPlaceholder,
	        value: designerValue,
	        onChange: setDesignerValue
	      }),
	      _react2.default.createElement(_textBox2.default, {
	        id: _text2.default.FORMS.yearId,
	        label: _text2.default.FORMS.yearLabel,
	        placeholder: _text2.default.FORMS.yearPlaceholder,
	        value: yearValue,
	        onChange: setYearValue
	      }),
	      _react2.default.createElement(_dropDown2.default, {
	        id: _text2.default.FORMS.productionLocationId,
	        label: _text2.default.FORMS.productionLocationLabel,
	        options: _text2.default.FORMS.productionLocationOptions,
	        value: productionLocationValue,
	        onChange: setProductionLocationValue
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imageSelection = __webpack_require__(40);
	
	var _imageSelection2 = _interopRequireDefault(_imageSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var images = _ref.images,
	      setImages = _ref.setImages,
	      mainImageValue = _ref.mainImageValue,
	      setMainImageValue = _ref.setMainImageValue;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_imageSelection2.default, {
	      images: images,
	      onChange: setImages,
	      requiresMain: true,
	      setMainImageValue: setMainImageValue,
	      mainImageValue: mainImageValue
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _relatedItemsSelection = __webpack_require__(41);
	
	var _relatedItemsSelection2 = _interopRequireDefault(_relatedItemsSelection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var relatedItems = _ref.relatedItems,
	      setRelatedItems = _ref.setRelatedItems;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_relatedItemsSelection2.default, {
	      selectedItems: relatedItems,
	      onChange: setRelatedItems
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _emailInput = __webpack_require__(20);
	
	var _emailInput2 = _interopRequireDefault(_emailInput);
	
	var _errorMessage = __webpack_require__(17);
	
	var _errorMessage2 = _interopRequireDefault(_errorMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var emailValue = _ref.emailValue,
	      setEmailValue = _ref.setEmailValue,
	      formValid = _ref.formValid,
	      validationMessage = _ref.validationMessage;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_emailInput2.default, { emailValue: emailValue, setEmailValue: setEmailValue }),
	    !formValid && _react2.default.createElement(_errorMessage2.default, {
	      title: 'Form not complete for submission',
	      message: validationMessage
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(144);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _subHeading = __webpack_require__(48);
	
	var _subHeading2 = _interopRequireDefault(_subHeading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var setForm = _ref.setForm,
	      closeForm = _ref.closeForm;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(_subHeading2.default, { text: 'Select a method' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'How would you like to contribute?'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.twoButtons },
	      _react2.default.createElement(_pillButton2.default, {
	        theme: 'blue',
	        text: 'Edit details',
	        onClick: function onClick() {
	          return setForm('editItem');
	        }
	      }),
	      _react2.default.createElement(_pillButton2.default, {
	        theme: 'blue',
	        text: 'Upload images',
	        onClick: function onClick() {
	          return setForm('images');
	        }
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.twoButtons },
	      _react2.default.createElement(_pillButton2.default, {
	        theme: 'blue',
	        text: 'Submit details',
	        onClick: function onClick() {
	          return setForm('general');
	        }
	      }),
	      _react2.default.createElement(_pillButton2.default, {
	        theme: 'blue',
	        text: 'Add a memory',
	        onClick: function onClick() {
	          return setForm('memory');
	        }
	      })
	    ),
	    _react2.default.createElement(_pillButton2.default, { theme: 'grey-ghost', text: 'Cancel', onClick: closeForm })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-forms-select-form----styles-module---container---3sSLZ","twoButtons":"src-components-contribution-form-forms-select-form----styles-module---twoButtons---1tJV7"};

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _forms;
	
	// Starting point
	
	
	// Specific forms
	
	
	// Submitting states
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(151);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stylesModule = __webpack_require__(148);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _selectForm = __webpack_require__(117);
	
	var _selectForm2 = _interopRequireDefault(_selectForm);
	
	var _generalForm = __webpack_require__(108);
	
	var _generalForm2 = _interopRequireDefault(_generalForm);
	
	var _imageForm = __webpack_require__(109);
	
	var _imageForm2 = _interopRequireDefault(_imageForm);
	
	var _memoryForm = __webpack_require__(110);
	
	var _memoryForm2 = _interopRequireDefault(_memoryForm);
	
	var _newItemForm = __webpack_require__(111);
	
	var _newItemForm2 = _interopRequireDefault(_newItemForm);
	
	var _editItemForm = __webpack_require__(102);
	
	var _editItemForm2 = _interopRequireDefault(_editItemForm);
	
	var _submissionRequestHandler = __webpack_require__(161);
	
	var _submissionRequestHandler2 = _interopRequireDefault(_submissionRequestHandler);
	
	var _submitting = __webpack_require__(121);
	
	var _submitting2 = _interopRequireDefault(_submitting);
	
	var _submissionSuccessful = __webpack_require__(120);
	
	var _submissionSuccessful2 = _interopRequireDefault(_submissionSuccessful);
	
	var _submissionFailed = __webpack_require__(119);
	
	var _submissionFailed2 = _interopRequireDefault(_submissionFailed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var freezeBodyScroll = function freezeBodyScroll(addClass) {
	  return addClass ? setTimeout(function () {
	    return document.getElementById('wf-content').classList.add('content-hide');
	  }, 250) : document.getElementById('wf-content').classList.remove('content-hide');
	};
	
	var forms = (_forms = {}, _forms[null] = _selectForm2.default, _forms.general = _generalForm2.default, _forms.memory = _memoryForm2.default, _forms.images = _imageForm2.default, _forms.newItem = _newItemForm2.default, _forms.editItem = _editItemForm2.default, _forms);
	
	var a = function a(action, label) {
	  return ga('send', {
	    hitType: 'event',
	    eventCategory: 'ContributionForm',
	    eventAction: action,
	    eventLabel: label
	  });
	};
	
	var ContributionForm = function (_Component) {
	  _inherits(ContributionForm, _Component);
	
	  function ContributionForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContributionForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      form: null,
	      open: false,
	
	      submitting: false,
	      formData: null,
	      recoveryState: null,
	
	      submitted: false,
	      submissionSuccessful: null,
	      errorCode: null
	    }, _this.setForm = function (form) {
	      a('SelectForm', form);
	      _this.setState({ form: form });
	    }, _this.clearForm = function (form) {
	      return _this.setState({
	        form: null,
	        formData: null,
	        recoveryState: null
	      });
	    }, _this.closeForm = function () {
	      freezeBodyScroll(false);
	      _this.setState({ open: false });
	      setTimeout(_this.props.closeForm, 250);
	    }, _this.submitForm = function (formData, recoveryState) {
	      a('SubmitForm', _this.state.form);
	      _this.setState({
	        submitting: true,
	        formData: formData,
	        recoveryState: recoveryState
	      });
	
	      (0, _submissionRequestHandler2.default)(_this.state.form, _this.props.itemId, formData).then(function (result) {
	        if (result === true) {
	          a('SubmissionSuccessful', _this.state.form);
	        } else if (result && result.errorCode === 'REQUEST_TOO_LARGE') {
	          a('SubmissionFailed-RequestTooLarge', _this.state.form);
	        } else {
	          a('SubmissionFailed-GenericError', _this.state.form);
	        }
	
	        _this.setState({
	          submitting: false,
	          submitted: true,
	          submissionSuccessful: result === true,
	          errorCode: result === true ? null : result.errorCode || 'GENERIC_ERROR'
	        });
	      });
	    }, _this.backToForm = function () {
	      a('BackToInput', _this.state.form);
	      _this.setState({
	        submitted: false,
	        submissionSuccessful: null,
	        errorCode: null
	      });
	    }, _this.retrySubmission = function () {
	      a('RetrySubmission', _this.state.form);
	      _this.submitForm(_this.state.formData, _this.state.recoveryState);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ContributionForm.prototype.componentWillMount = function componentWillMount() {
	    a('OpenForm', this.props.form);
	    this.setState({ form: this.props.form });
	    freezeBodyScroll(true);
	  };
	
	  ContributionForm.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    setTimeout(function () {
	      return _this2.setState({ open: true });
	    }, 0);
	  };
	
	  ContributionForm.prototype.componentWillUnmount = function componentWillUnmount() {
	    a('CloseForm', this.state.form);
	    freezeBodyScroll(false);
	  };
	
	  ContributionForm.prototype.render = function render() {
	    return _reactDom2.default.createPortal(this.renderForm(), document.getElementById('wf-modals'));
	  };
	
	  ContributionForm.prototype.renderForm = function renderForm() {
	    var _this3 = this;
	
	    var _state = this.state,
	        submitting = _state.submitting,
	        submitted = _state.submitted,
	        submissionSuccessful = _state.submissionSuccessful,
	        errorCode = _state.errorCode;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)(_stylesModule2.default.container, this.state.open && _stylesModule2.default.isOpen)
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.scrollContainer },
	        function () {
	          if (submitting) {
	            return _react2.default.createElement(_submitting2.default, null);
	          } else if (submitted && submissionSuccessful) {
	            return _react2.default.createElement(_submissionSuccessful2.default, { closeForm: _this3.closeForm });
	          } else if (submitted && !submissionSuccessful) {
	            return _react2.default.createElement(_submissionFailed2.default, {
	              errorCode: errorCode,
	              backToForm: _this3.backToForm,
	              retrySubmission: _this3.retrySubmission
	            });
	          } else {
	            return _react2.default.createElement(forms[_this3.state.form], {
	              form: _this3.state.form,
	              setForm: _this3.setForm,
	              submitForm: _this3.submitForm,
	              clearForm: _this3.clearForm,
	              closeForm: _this3.closeForm,
	              secondaryButtonIsBack: !_this3.props.form,
	              recoveryState: _this3.state.recoveryState,
	              itemId: _this3.props.itemId
	            });
	          }
	        }()
	      )
	    );
	  };
	
	  return ContributionForm;
	}(_react.Component);
	
	exports.default = ContributionForm;
	module.exports = exports['default'];

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(145);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _Cross = __webpack_require__(28);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ERROR_MESSAGES = {
	  OFFLINE: _react2.default.createElement(
	    'p',
	    null,
	    'It looks like you are currently offline. Please reconnect and try again.'
	  ),
	  GENERIC_ERROR: _react2.default.createElement(
	    'p',
	    null,
	    'There may be an issue with our system. Please try again later.'
	  ),
	  REQUEST_TOO_LARGE: _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'The size of your uploads is too large for us to process.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Unfortunately for technical reasons we can only accept submissions of up to 6MB in size. If you have any images that are larger than 6MB individually please reduce their file size before submitting them. If you have multiple images please try sending several submissions so that each submission is\xA0less\xA0than\xA06MB.'
	    )
	  )
	};
	
	exports.default = function (_ref) {
	  var _ref$errorCode = _ref.errorCode,
	      errorCode = _ref$errorCode === undefined ? 'GENERIC_ERROR' : _ref$errorCode,
	      backToForm = _ref.backToForm,
	      retrySubmission = _ref.retrySubmission;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(_Cross2.default, { size: 96, color: '#AD343E' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Failed to send submission'
	    ),
	    navigator.onLine ? ERROR_MESSAGES[errorCode] : ERROR_MESSAGES.OFFLINE,
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.buttons },
	      _react2.default.createElement(_pillButton2.default, { theme: 'grey-ghost', text: 'Back', onClick: backToForm }),
	      (!navigator.onLine || errorCode !== 'REQUEST_TOO_LARGE') && _react2.default.createElement(_pillButton2.default, { theme: 'blue', text: 'Retry', onClick: retrySubmission })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-state-pages-submission-failed----styles-module---container---3_QKD","buttons":"src-components-contribution-form-state-pages-submission-failed----styles-module---buttons---wBCFv"};

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(146);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _Tick = __webpack_require__(62);
	
	var _Tick2 = _interopRequireDefault(_Tick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var closeForm = _ref.closeForm;
	  return _react2.default.createElement(
	    'div',
	    { id: 'form-submission-successful', className: _stylesModule2.default.container },
	    _react2.default.createElement(_Tick2.default, { size: 96, color: '#56ad65' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Your submission was successful'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We will need to review your submission before it can be published to the site.'
	    ),
	    _react2.default.createElement(_pillButton2.default, { theme: 'blue', text: 'Finish', onClick: closeForm })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-state-pages-submission-successful----styles-module---container---23fum"};

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(147);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _loadingIndicator = __webpack_require__(162);
	
	var _loadingIndicator2 = _interopRequireDefault(_loadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var closeForm = _ref.closeForm,
	      secondaryButtonIsBack = _ref.secondaryButtonIsBack,
	      clearForm = _ref.clearForm;
	  return _react2.default.createElement(
	    'div',
	    { id: 'form-submitting', className: _stylesModule2.default.container },
	    _react2.default.createElement(_loadingIndicator2.default, null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Sending your submission'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Please wait...'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form-state-pages-submitting----styles-module---container---2Ldjy"};

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-contribution-form----styles-module---container---1R3bm","isOpen":"src-components-contribution-form----styles-module---isOpen---3Cqlw","scrollContainer":"src-components-contribution-form----styles-module---scrollContainer---scAI5"};

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(149);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _Profile = __webpack_require__(127);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _itemLink = __webpack_require__(72);
	
	var _itemLink2 = _interopRequireDefault(_itemLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	var dateFormat = function dateFormat(timestamp) {
	  var date = new Date(timestamp);
	  return months[date.getMonth()] + ' ' + date.getFullYear();
	};
	
	var paragraphs = function paragraphs(text) {
	  return text.split('\n').map(function (part, index) {
	    return _react2.default.createElement(
	      'p',
	      { key: index },
	      part
	    );
	  });
	};
	
	exports.default = function (_ref) {
	  var submissionDate = _ref.submissionDate,
	      name = _ref.name,
	      personType = _ref.personType,
	      text = _ref.text,
	      memoryDate = _ref.memoryDate,
	      relatedItems = _ref.relatedItems;
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.top },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.profileIcon },
	        _react2.default.createElement(_Profile2.default, { size: 64, color: '#fff' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.nameAndTime },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.name },
	          _react2.default.createElement(
	            'span',
	            null,
	            name
	          ),
	          personType !== 'OTHER' && _text2.default.PERSON_TYPES[personType] && _react2.default.createElement(
	            'span',
	            { className: _stylesModule2.default.badge },
	            _text2.default.PERSON_TYPES[personType]
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.date },
	          'Submitted ',
	          dateFormat(submissionDate)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.message },
	      memoryDate && _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.memoryDate },
	        'Memory date: ',
	        memoryDate
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.text },
	        paragraphs(text)
	      ),
	      relatedItems.length > 0 && _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.relatedItems },
	        _react2.default.createElement(
	          'div',
	          null,
	          'Related Items'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          relatedItems.map(function (relatedItem) {
	            return _react2.default.createElement(
	              'li',
	              { key: relatedItem },
	              _react2.default.createElement(_itemLink2.default, {
	                id: relatedItem,
	                imageSizes: '(min-width: 1200px) 244px, (min-width: 1024px) calc(25vw - 4rem), (min-width: 768px) calc(33vw - 6rem), calc(50vw - 10rem)'
	              })
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 149:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-memory----styles-module---container----ZmXk","top":"src-components-memory----styles-module---top---3yLvo","profileIcon":"src-components-memory----styles-module---profileIcon---2b0Cn","message":"src-components-memory----styles-module---message---1r3xp","nameAndTime":"src-components-memory----styles-module---nameAndTime---pXTpc","name":"src-components-memory----styles-module---name---qkEkw","badge":"src-components-memory----styles-module---badge---7N4p5","date":"src-components-memory----styles-module---date---DKn7g","text":"src-components-memory----styles-module---text---2Ncfk","memoryDate":"src-components-memory----styles-module---memoryDate---2nt8_","relatedItems":"src-components-memory----styles-module---relatedItems---2tfvG"};

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === undefined ? 16 : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color,
	      _ref$direction = _ref.direction,
	      direction = _ref$direction === undefined ? 'right' : _ref$direction;
	  return _react2.default.createElement(
	    'svg',
	    {
	      height: size,
	      width: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 24 24'
	    },
	    _react2.default.createElement('path', {
	      style: direction === 'left' ? { transformOrigin: '50% 50%', transform: 'rotate(180deg)' } : null,
	      fill: color,
	      d: 'M22 12l-4-4v3H3v2h15v3z'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === undefined ? 16 : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	  return _react2.default.createElement(
	    'svg',
	    {
	      height: size,
	      width: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 1024 1024'
	    },
	    _react2.default.createElement('path', {
	      fill: color,
	      stroke: color,
	      d: 'M304 576c0 114.876 93.124 208 208 208s208-93.124 208-208-93.124-208-208-208-208 93.124-208 208zM960 224h-224c-16-64-32-128-96-128h-256c-64 0-80 64-96 128h-224c-35.2 0-64 28.8-64 64v576c0 35.2 28.8 64 64 64h896c35.2 0 64-28.8 64-64v-576c0-35.2-28.8-64-64-64zM512 860c-156.85 0-284-127.148-284-284 0-156.85 127.15-284 284-284 156.852 0 284 127.15 284 284 0 156.852-127.146 284-284 284zM960 416h-128v-64h128v64z'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === undefined ? 16 : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	  return _react2.default.createElement(
	    'svg',
	    {
	      height: size,
	      width: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 1024 1024'
	    },
	    _react2.default.createElement('path', {
	      fill: color,
	      stroke: color,
	      d: 'M967.111 170.666h-56.889v-56.889c0-31.289-25.6-56.889-56.889-56.889h-796.444c-31.289 0-56.889 25.6-56.889 56.889v682.667c0 31.289 25.6 56.889 56.889 56.889h56.889v56.889c0 31.289 25.6 56.889 56.889 56.889h796.444c31.289 0 56.889-25.6 56.889-56.889v-682.667c0-31.289-25.6-56.889-56.889-56.889zM113.778 227.555v568.889h-56.788c-0.036-0.030-0.073-0.068-0.101-0.103v-682.462c0.030-0.036 0.068-0.073 0.101-0.101h796.24c0.036 0.030 0.073 0.068 0.103 0.103v56.786h-682.667c-31.289 0-56.889 25.6-56.889 56.889v0zM967.111 910.118c-0.030 0.036-0.068 0.073-0.103 0.103h-796.24c-0.036-0.030-0.073-0.068-0.101-0.103v-682.462c0.030-0.036 0.068-0.073 0.101-0.101h796.24c0.036 0.030 0.073 0.068 0.103 0.103v682.46z'
	    }),
	    _react2.default.createElement('path', {
	      fill: color,
	      stroke: color,
	      d: 'M853.333 369.777c0 47.129-38.204 85.333-85.333 85.333s-85.333-38.204-85.333-85.333 38.204-85.333 85.333-85.333 85.333 38.204 85.333 85.333z'
	    }),
	    _react2.default.createElement('path', {
	      fill: color,
	      stroke: color,
	      d: 'M910.222 853.332h-682.667v-113.778l199.111-341.333 227.556 284.444h56.889l199.111-170.667z'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === undefined ? 16 : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	  return _react2.default.createElement(
	    'svg',
	    {
	      height: size,
	      width: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 1024 1024'
	    },
	    _react2.default.createElement('path', {
	      style: {
	        transform: 'scale(0.75) rotate(45deg)',
	        transformOrigin: 'center'
	      },
	      fill: color,
	      d: 'M960.001 0q27.5 0 45.75 18.251t18.251 45.75q0 27-18.5 45.5l-403.001 402.5 403.001 402.5q18.5 18.5 18.5 45.5 0 27.5-18.251 45.75t-45.75 18.251q-27 0-45.5-18.5l-402.5-403.001-402.5 403.001q-18.5 18.5-45.5 18.5-27.5 0-45.75-18.251t-18.251-45.75q0-27 18.5-45.5l403.001-402.5-403.001-402.5q-18.5-18.5-18.5-45.5 0-27.5 18.251-45.75t45.75-18.251q27 0 45.5 18.5l402.5 403.001 402.5-403.001q18.5-18.5 45.5-18.5z'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === undefined ? 16 : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	  return _react2.default.createElement(
	    'svg',
	    {
	      height: size,
	      width: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 1024 1024'
	    },
	    _react2.default.createElement('path', {
	      fill: color,
	      stroke: color,
	      d: 'M576 706.612v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h896c0-128.968-166.898-235.64-384-253.388z'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$size = _ref.size,
	      size = _ref$size === undefined ? 16 : _ref$size,
	      _ref$color = _ref.color,
	      color = _ref$color === undefined ? '#000' : _ref$color;
	  return _react2.default.createElement(
	    'svg',
	    {
	      height: size,
	      width: size,
	      xmlns: 'http://www.w3.org/2000/svg',
	      viewBox: '0 0 24 24'
	    },
	    _react2.default.createElement('path', {
	      fill: color,
	      d: 'M13 13h-2V7h2m0 10h-2v-2h2M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2z'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _stylesModule = __webpack_require__(645);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatParagraph = function formatParagraph(paragraph) {
	  return paragraph.split('\n').reduce(function (result, part, key) {
	    return [].concat(result, [_react2.default.createElement('br', { key: key }), part]);
	  }, []).splice(1);
	};
	
	var formatDescription = function formatDescription(description) {
	  return description.split('\n\n').map(function (paragraph, key) {
	    return _react2.default.createElement(
	      'p',
	      { key: key },
	      formatParagraph(paragraph)
	    );
	  });
	};
	
	exports.default = function (_ref) {
	  var description = _ref.description;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _stylesModule2.default.container },
	    description ? formatDescription(description) : _react2.default.createElement(
	      'p',
	      null,
	      'No description has been added for this item. Help out by adding one!'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-page-components-glass-detail-description----styles-module---container---1Mcai"};

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(12);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _stylesModule = __webpack_require__(646);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _square = __webpack_require__(56);
	
	var _square2 = _interopRequireDefault(_square);
	
	var _itemImage = __webpack_require__(246);
	
	var _itemImage2 = _interopRequireDefault(_itemImage);
	
	var _imagePlaceholder = __webpack_require__(245);
	
	var _imagePlaceholder2 = _interopRequireDefault(_imagePlaceholder);
	
	var _Gallery = __webpack_require__(328);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _Camera = __webpack_require__(326);
	
	var _Camera2 = _interopRequireDefault(_Camera);
	
	var _Cross = __webpack_require__(28);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gallery = function (_Component) {
	  _inherits(Gallery, _Component);
	
	  function Gallery() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Gallery);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      active: 0,
	      overlayOpen: false
	    }, _this.toggleGallery = function () {
	      ga('send', {
	        hitType: 'event',
	        eventCategory: 'Gallery',
	        eventAction: _this.state.overlayOpen ? 'CloseGallery' : 'OpenGallery',
	        eventLabel: _this.props.itemId
	      });
	      _this.setState({ overlayOpen: !_this.state.overlayOpen });
	    }, _this.setSelectedImage = function (active) {
	      return _this.setState({ active: active });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Gallery.prototype.render = function render() {
	    var _this2 = this,
	        _classnames;
	
	    var _props = this.props,
	        itemId = _props.itemId,
	        addImage = _props.addImage,
	        editImages = _props.editImages,
	        images = _props.images,
	        title = _props.title;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.container },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.mainImage },
	        images.length > 0 ? _react2.default.createElement(
	          _square2.default,
	          null,
	          _react2.default.createElement(
	            'button',
	            {
	              className: _stylesModule2.default.focusedImageButton,
	              onClick: this.toggleGallery
	            },
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.imageContainer },
	              _react2.default.createElement(_itemImage2.default, {
	                itemId: itemId,
	                imageId: images[this.state.active],
	                sizeOverride: '80-blur'
	              }),
	              _react2.default.createElement(_itemImage2.default, {
	                itemId: itemId,
	                imageId: images[this.state.active],
	                sizes: '(min-width: 1200px) 440px, (min-width: 768px) calc(50vw - 10rem), calc(100vw - 4rem)',
	                alt: 'Image of ' + title
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: _stylesModule2.default.buttonText },
	                'View larger image'
	              )
	            )
	          )
	        ) : _react2.default.createElement(_imagePlaceholder2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.manageLinks },
	        _react2.default.createElement(
	          'button',
	          { onClick: addImage },
	          _react2.default.createElement(_Camera2.default, { size: 24, color: '#fff' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Add Images'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames3.default)(_stylesModule2.default.links, _stylesModule2.default.pageLinks) },
	        _react2.default.createElement(
	          'ul',
	          null,
	          images.length > 0 && _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                className: _stylesModule2.default.galleryButton,
	                onClick: this.toggleGallery
	              },
	              _react2.default.createElement(_Gallery2.default, { size: 24, color: '#fff' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Gallery'
	              )
	            )
	          ),
	          images.map(function (image, index) {
	            return _react2.default.createElement(
	              'li',
	              { key: image },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: _stylesModule2.default.imageButton,
	                  onClick: function onClick() {
	                    return _this2.setSelectedImage(index);
	                  }
	                },
	                _react2.default.createElement(
	                  _square2.default,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: _stylesModule2.default.imageContainer },
	                    _react2.default.createElement(_itemImage2.default, {
	                      itemId: itemId,
	                      imageId: image,
	                      sizeOverride: '80-blur'
	                    }),
	                    _react2.default.createElement(_itemImage2.default, { itemId: itemId, imageId: image, sizes: '80px' })
	                  )
	                )
	              )
	            );
	          })
	        )
	      ),
	      images.length > 0 && _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames3.default)(_stylesModule2.default.overlay, (_classnames = {}, _classnames[_stylesModule2.default.open] = this.state.overlayOpen, _classnames))
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.nav },
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.links },
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: _stylesModule2.default.galleryButton,
	                    onClick: this.toggleGallery
	                  },
	                  _react2.default.createElement(_Cross2.default, { size: 24, color: '#fff' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Exit'
	                  )
	                )
	              ),
	              images.map(function (image, index) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: image },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: _stylesModule2.default.imageButton,
	                      onClick: function onClick() {
	                        return _this2.setSelectedImage(index);
	                      }
	                    },
	                    _react2.default.createElement(
	                      _square2.default,
	                      null,
	                      _react2.default.createElement(
	                        'div',
	                        { className: _stylesModule2.default.imageContainer },
	                        _react2.default.createElement(_itemImage2.default, {
	                          itemId: itemId,
	                          imageId: image,
	                          sizeOverride: '80-blur'
	                        }),
	                        _react2.default.createElement(_itemImage2.default, {
	                          itemId: itemId,
	                          imageId: image,
	                          sizes: '80px'
	                        })
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.galleryImage },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_itemImage2.default, {
	              itemId: itemId,
	              imageId: images[this.state.active],
	              sizes: '(min-width: 768px) calc(100vw - 9rem), calc(100vw - 2rem)'
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return Gallery;
	}(_react.Component);
	
	exports.default = Gallery;
	module.exports = exports['default'];

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-page-components-glass-detail-gallery----styles-module---container---1b6l5","manageLinks":"src-page-components-glass-detail-gallery----styles-module---manageLinks---2w_SJ","galleryButton":"src-page-components-glass-detail-gallery----styles-module---galleryButton---3-J5y","imageButton":"src-page-components-glass-detail-gallery----styles-module---imageButton---VlU8D","links":"src-page-components-glass-detail-gallery----styles-module---links---mZI5s","focusedImageButton":"src-page-components-glass-detail-gallery----styles-module---focusedImageButton---1BtBv","buttonText":"src-page-components-glass-detail-gallery----styles-module---buttonText---3den7","mainImage":"src-page-components-glass-detail-gallery----styles-module---mainImage---1HFdl","imageContainer":"src-page-components-glass-detail-gallery----styles-module---imageContainer---OaD-o","overlay":"src-page-components-glass-detail-gallery----styles-module---overlay---2MjVs","open":"src-page-components-glass-detail-gallery----styles-module---open---2n3V4","nav":"src-page-components-glass-detail-gallery----styles-module---nav---3IU2b","galleryImage":"src-page-components-glass-detail-gallery----styles-module---galleryImage---3w5xY","pageLinks":"src-page-components-glass-detail-gallery----styles-module---pageLinks---1T8Ne"};

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stylesModule = __webpack_require__(647);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _backgroundContainer = __webpack_require__(33);
	
	var _backgroundContainer2 = _interopRequireDefault(_backgroundContainer);
	
	var _gridWrap = __webpack_require__(34);
	
	var _gridWrap2 = _interopRequireDefault(_gridWrap);
	
	var _room = __webpack_require__(46);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _Arrow = __webpack_require__(125);
	
	var _Arrow2 = _interopRequireDefault(_Arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var heading = _ref.heading;
	  return _react2.default.createElement(
	    _backgroundContainer2.default,
	    { src: _room2.default },
	    _react2.default.createElement(
	      _gridWrap2.default,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.container },
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.back },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/glass' },
	            _react2.default.createElement(_Arrow2.default, { color: '#fff', size: 32, direction: 'left' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              'View all items'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.heading },
	          _react2.default.createElement(
	            'h1',
	            null,
	            heading
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-page-components-glass-detail-header----styles-module---container---2DBk8","back":"src-page-components-glass-detail-header----styles-module---back---1_V0_","heading":"src-page-components-glass-detail-header----styles-module---heading---TeKCU"};

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(32);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _stylesModule = __webpack_require__(649);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _glassData = __webpack_require__(24);
	
	var _glassData2 = _interopRequireDefault(_glassData);
	
	var _memories = __webpack_require__(99);
	
	var _memories2 = _interopRequireDefault(_memories);
	
	var _gridWrap = __webpack_require__(34);
	
	var _gridWrap2 = _interopRequireDefault(_gridWrap);
	
	var _pillButton = __webpack_require__(8);
	
	var _pillButton2 = _interopRequireDefault(_pillButton);
	
	var _siteFooter = __webpack_require__(42);
	
	var _siteFooter2 = _interopRequireDefault(_siteFooter);
	
	var _contributionForm = __webpack_require__(118);
	
	var _contributionForm2 = _interopRequireDefault(_contributionForm);
	
	var _header = __webpack_require__(342);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _gallery = __webpack_require__(341);
	
	var _gallery2 = _interopRequireDefault(_gallery);
	
	var _description = __webpack_require__(340);
	
	var _description2 = _interopRequireDefault(_description);
	
	var _memories3 = __webpack_require__(344);
	
	var _memories4 = _interopRequireDefault(_memories3);
	
	var _related = __webpack_require__(345);
	
	var _related2 = _interopRequireDefault(_related);
	
	var _camelToDisplayText = __webpack_require__(190);
	
	var _camelToDisplayText2 = _interopRequireDefault(_camelToDisplayText);
	
	var _textMapping = __webpack_require__(192);
	
	var _textMapping2 = _interopRequireDefault(_textMapping);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageSection = function PageSection(_ref) {
	  var title = _ref.title,
	      buttonText = _ref.buttonText,
	      buttonOnClick = _ref.buttonOnClick,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'section',
	    null,
	    title && _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.header },
	      _react2.default.createElement(
	        'h2',
	        null,
	        title
	      ),
	      buttonText && _react2.default.createElement(_pillButton2.default, { small: true, text: buttonText, onClick: buttonOnClick })
	    ),
	    children
	  );
	};
	
	var GlassDetail = function (_Component) {
	  _inherits(GlassDetail, _Component);
	
	  function GlassDetail() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GlassDetail);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      contributingOpen: false,
	      contributingForm: null
	    }, _this.openContributing = function (view) {
	      return _this.setState({ contributingOpen: true, contributingForm: view });
	    }, _this.closeContributing = function (view) {
	      return _this.setState({ contributingOpen: false, contributingForm: null });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  GlassDetail.prototype.render = function render() {
	    var _this2 = this;
	
	    var id = this.props.pathContext.id;
	
	    var object = _glassData2.default.find(function (item) {
	      return item.id === id;
	    });
	
	    var attributes = object.data || {};
	    var attributeNames = Object.keys(attributes);
	    attributeNames.sort(function (a, b) {
	      return a.localeCompare(b);
	    });
	
	    var images = object.images || [];
	
	    var memories = _memories2.default.filter(function (memory) {
	      return memory.relatedItems.includes(id);
	    }).map(function (memory) {
	      return _extends({}, memory, {
	        relatedItems: memory.relatedItems.filter(function (relatedItem) {
	          return relatedItem !== id;
	        })
	      });
	    }).sort(function (a, b) {
	      return a.submissionDate < b.submissionDate;
	    });
	
	    return _react2.default.createElement(
	      'div',
	      { className: _stylesModule2.default.container },
	      _react2.default.createElement(_reactHelmet2.default, { title: object.title }),
	      _react2.default.createElement(_header2.default, { heading: object.title }),
	      _react2.default.createElement(
	        _gridWrap2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { width: '100%' } },
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.topSection },
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.topLhs },
	              _react2.default.createElement(_gallery2.default, {
	                itemId: id,
	                images: images,
	                addImage: function addImage() {
	                  return _this2.openContributing('images');
	                },
	                editImages: function editImages() {
	                  return _this2.openContributing('editImages');
	                },
	                title: object.title
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.topRhs },
	              _react2.default.createElement(
	                'dl',
	                null,
	                attributeNames.map(function (attributeName) {
	                  return _react2.default.createElement(
	                    _react.Fragment,
	                    { key: attributeName },
	                    _react2.default.createElement(
	                      'dt',
	                      null,
	                      (0, _camelToDisplayText2.default)(attributeName)
	                    ),
	                    _react2.default.createElement(
	                      'dd',
	                      null,
	                      (0, _textMapping2.default)(attributeName, attributes[attributeName])
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            PageSection,
	            { title: 'About this item' },
	            _react2.default.createElement(_description2.default, { description: object.description })
	          ),
	          _react2.default.createElement(
	            PageSection,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: _stylesModule2.default.contributeCta },
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Contribute'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'If you have any additional information or images to contribute for this item please do so using our contribution form! We\'ll review your contribution and let you know when it has been published.'
	              ),
	              _react2.default.createElement(_pillButton2.default, {
	                text: 'Contribute',
	                onClick: function onClick() {
	                  return _this2.openContributing(null);
	                }
	              })
	            )
	          ),
	          object.relatedItems.length > 0 && _react2.default.createElement(
	            PageSection,
	            { title: 'Related Items' },
	            _react2.default.createElement(_related2.default, { relatedItems: object.relatedItems })
	          ),
	          _react2.default.createElement(
	            PageSection,
	            {
	              title: 'Memories',
	              buttonText: 'Add a memory',
	              buttonOnClick: function buttonOnClick() {
	                return _this2.openContributing('memory');
	              }
	            },
	            _react2.default.createElement(_memories4.default, { memories: memories })
	          ),
	          this.state.contributingOpen && _react2.default.createElement(_contributionForm2.default, {
	            itemId: id,
	            form: this.state.contributingForm,
	            closeForm: this.closeContributing
	          })
	        )
	      ),
	      _react2.default.createElement(_siteFooter2.default, null)
	    );
	  };
	
	  return GlassDetail;
	}(_react.Component);
	
	exports.default = GlassDetail;
	module.exports = exports['default'];

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(12);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _memory = __webpack_require__(123);
	
	var _memory2 = _interopRequireDefault(_memory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$memories = _ref.memories,
	      memories = _ref$memories === undefined ? [] : _ref$memories;
	  return _react2.default.createElement(
	    'div',
	    null,
	    !memories.length ? _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'No one has added a memory related to this object yet.'
	      )
	    ) : _react2.default.createElement(
	      'ul',
	      null,
	      memories.map(function (memoryDetails, index) {
	        return _react2.default.createElement(
	          'li',
	          { key: index },
	          _react2.default.createElement(_memory2.default, memoryDetails)
	        );
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesModule = __webpack_require__(648);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _itemLink = __webpack_require__(72);
	
	var _itemLink2 = _interopRequireDefault(_itemLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var _ref$relatedItems = _ref.relatedItems,
	      relatedItems = _ref$relatedItems === undefined ? [] : _ref$relatedItems;
	  return _react2.default.createElement(
	    'ul',
	    { className: _stylesModule2.default.container },
	    relatedItems.map(function (id) {
	      return _react2.default.createElement(
	        'li',
	        { key: id },
	        _react2.default.createElement(_itemLink2.default, {
	          id: id,
	          imageSizes: '(min-width: 1200px) 244px, (min-width: 768px) calc(25vw - 2.75rem), calc(50vw - 3rem)'
	        })
	      );
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-page-components-glass-detail-related----styles-module---container---2wYSp"};

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-page-components-glass-detail----styles-module---container---v7BHb","topSection":"src-page-components-glass-detail----styles-module---topSection---1T8Rx","topLhs":"src-page-components-glass-detail----styles-module---topLhs---1K22Q","topRhs":"src-page-components-glass-detail----styles-module---topRhs---3656r","header":"src-page-components-glass-detail----styles-module---header---ZsKH3","contributeCta":"src-page-components-glass-detail----styles-module---contributeCta---1AGcx"};

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (string) {
	  return string.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
	    return str.toUpperCase();
	  });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _text = __webpack_require__(4);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textMapping = function textMapping(filterName, filterValue) {
	  var text = void 0;
	
	  if (filterName === 'glassType') {
	    text = _text2.default.MAPPINGS.GLASS_TYPES[filterValue];
	  } else if (filterName === 'productionLocation') {
	    text = _text2.default.MAPPINGS.PRODUCTION_LOCATIONS[filterValue];
	  } else if (filterName === 'productionMethod') {
	    text = _text2.default.MAPPINGS.PRODUCTION_METHODS[filterValue];
	  } else {
	    text = filterValue;
	  }
	
	  return text || 'Unknown';
	};
	
	exports.default = textMapping;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-page-components-glass-detail-index-js-6fef8bca6ac34f85c459.js